import { ReactElement } from 'react';

import { TherapeuticGroupIssue } from '@dreryk/egabinet-group-session-frontend-api';

import { BindingCreator, useTranslate } from '@dreryk/react-common';
import { FilterPanel, Select } from '@dreryk/react-components';

import {
   GroupSessionsFilterPanelFormBean,
   GroupSessionsFilterPanelSearchParam,
   GroupSessionsFilterPanelStorageKey,
} from '../../GroupSessionsFilterPanel.types';
import { translationKeys } from '../../../translations';
import { ISSUES } from '../../GroupSessionsFilterPanel.constants';

import { createIssueTriggerLabelExtractor, issueCodec, issueDeselectorsPropsMapper } from './IssueController.utils';
import { StyledIssueSelect } from './IssueSelect.styled';

type IssueControllerProps = {
   registerController: BindingCreator<GroupSessionsFilterPanelFormBean, 'issue'>;
};

export const IssueController = (props: IssueControllerProps): ReactElement => {
   const translate = useTranslate();
   return (
      <FilterPanel.Controller<GroupSessionsFilterPanelFormBean, 'issue'>
         name={'issue'}
         searchParam={GroupSessionsFilterPanelSearchParam.ISSUE}
         storageKey={GroupSessionsFilterPanelStorageKey.ISSUE}
         codec={issueCodec}
         chipsLabel={translationKeys.needsAttention}
         getDeselectorsProps={issueDeselectorsPropsMapper}
      >
         {({ applyFilter }) => (
            <StyledIssueSelect<TherapeuticGroupIssue>
               testId={'issue'}
               triggerLabelExtractor={createIssueTriggerLabelExtractor(translate)}
               controller={props.registerController('issue')}
               onHide={applyFilter}
               label={translationKeys.needsAttention}
               placeholder={translationKeys.chooseElementToCheck}
               compact
            >
               <>
                  <Select.List<TherapeuticGroupIssue> items={ISSUES}>
                     {(item) => <Select.Item item={item} label={translationKeys.issuesMap[item]} testId={item} />}
                  </Select.List>
               </>
            </StyledIssueSelect>
         )}
      </FilterPanel.Controller>
   );
};
